import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {CopyToClipboard} from "react-copy-to-clipboard"
import _ from 'lodash'

import SVG from 'react-inlinesvg'
import shareIcon from '@icons/share/primary'

const studentCredentialsText = (object) => {
  return I18n.t('groups.passwords.shared_credentials', {
    name: object.fullName,
    login: object.login,
    password: object.password
  }).replace(/\\n/g, '\n');
}

const content = (children) => {
  return children ? children : (
    <Fragment>
      <SVG src={shareIcon} />
      {I18n.t('groups.passwords.share')}
    </Fragment>
  )
}

const SharePasswordsButton = ({ students, callback, children, ...rest }) => {
  const objects = _.values(students);
  const isDeviceSupportsShare = Boolean(navigator.share);

  const text = _.map(objects, ({ object }) => studentCredentialsText(object)).join('\n\n')

  const share = (event) => {
    navigator
      .share({text: text})
      .then(() => {
        if (callback) { callback(event); }
      })
      .catch((e) => console.error(e))

    return false;
  }

  const copy = (event) => {
    if (callback) { callback(event); }
    return false;
  }

  return isDeviceSupportsShare ? (
    <a href="javascript:void(0)" onClick={share} className="link link--icon-left f--upper" {...rest}>
      { content(children) }
    </a>
  ) : (
    <CopyToClipboard text={text}>
      <a href="javascript:void(0)" onClick={copy} className="link link--icon-left f--upper" {...rest}>
        { content(children) }
      </a>
    </CopyToClipboard>
  )
}

SharePasswordsButton.propTypes = {
  students: PropTypes.array.isRequired,
  callback: PropTypes.func
}

export default SharePasswordsButton
